(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("expAnalyticsCollector", [], factory);
	else if(typeof exports === 'object')
		exports["expAnalyticsCollector"] = factory();
	else
		root["expAnalyticsCollector"] = factory();
})(self, function() {
return 